import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import WavyDivider from "@/components/site/WavyDivider";
import { DecorationField } from "@/components/site/Decorations";
import { IMG } from "@/lib/siteData";

/**
 * Inner-page hero banner with title + breadcrumb + blurred classroom background
 * and a wavy divider at the bottom.
 */
export default function PageHero({ title, crumb, crumbs, decorationVariant = "hero" }) {
  const trail = crumbs || [{ label: crumb || title }];
  return (
    <section
      className="relative pt-28 md:pt-36 pb-28 md:pb-36 overflow-hidden"
      data-testid="page-hero"
    >
      {/* background image with overlay */}
      <div className="absolute inset-0 -z-10">
        <img
          src={IMG.classroomBlur}
          alt=""
          className="w-full h-full object-cover scale-105 blur-[2px]"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-brand-purple-deep/75 via-brand-purple/55 to-brand-green-deep/70" />
      </div>

      <DecorationField variant={decorationVariant} />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 text-center text-white">
        <h1
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight drop-shadow-sm"
          data-testid="page-hero-title"
        >
          {title}
        </h1>
        <nav
          className="mt-4 flex items-center justify-center gap-2 text-[14px] sm:text-[15px] text-white/90"
          aria-label="Breadcrumb"
          data-testid="breadcrumb"
        >
          <Link to="/" className="hover:text-brand-yellow font-semibold">Home</Link>
          {trail.map((c, i) => (
            <React.Fragment key={c.label}>
              <ChevronRight className="h-4 w-4" />
              {c.to && i < trail.length - 1 ? (
                <Link to={c.to} className="hover:text-brand-yellow font-semibold">
                  {c.label}
                </Link>
              ) : (
                <span className="font-semibold text-brand-yellow">{c.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>

      <WavyDivider fill="#FFFCF9" />
    </section>
  );
}
